module.exports = __webpack_public_path__ + "img/turkiye-is-bankasi-isbox-kinect-04.77a7e634.jpg";